import { ExtendedDocumentReference } from '@seen/core/models/document-references/documentReferences'
import type { DocumentReviewTask } from '@seen/core/models/tasks/standard/documentReviewTask'
import type { ReactNode } from 'react'
import { Card } from '#src/components/core/Card.tsx'
import { DocumentReferenceDisplay } from '#src/components/document-reference/DocumentReferenceDisplay.tsx'
import { useRead } from '#src/hooks/useRead.ts'

interface DocumentReviewCardProps {
  task: DocumentReviewTask
}

export function DocumentReviewCard({
  task,
}: DocumentReviewCardProps): ReactNode {
  const { data: document } = useRead(ExtendedDocumentReference, task.document)

  if (!document) {
    return null
  }

  return (
    <Card>
      <DocumentReferenceDisplay
        documentReference={document.reference}
        hideDelete
        pollWhilePending={false}
      />
    </Card>
  )
}
